import React, { Component } from 'react';
import { selectors, actions } from '../sagas/accounting'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AccountingRow from './Row'
import TipRow from './TipRow'

class AccountingTable extends Component {

  render () {
    return (
      <div className={'table-row-wrapper'}>
        { this.props.activeTab === 'tips'
          && this.props.tips
          && this.props.tips.map( tip => {
            return(
              <TipRow tip={tip}/>
            )
          })
        }
        { this.props.activeTab === 'accounting'
          && this.props.accounting
          && this.props.accounting.map( accounting => {
            return(
              <AccountingRow key={accounting.id} accounting={accounting}/>
            )
          })
        }
      </div>
    );
  }

};

export default (AccountingTable)



// WEBPACK FOOTER //
// ./src/Accounting/AccountingTable.jsx